import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Input from '../Input';
import Divider from '../Divider';
import Header from '../Header';
import Loader from '../Loader';
import { noop } from '../../utils';
import styles from './Autocomplete.css';
import DropdownOption from '../../prop-types/DropdownOption';
var cx = classnames.bind(styles);
var DROPDOWN_OPTION_TOTAL_HEIGHT = 42.5;
export default function Autocomplete(_ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      options = _ref.options,
      value = _ref.value,
      onSelect = _ref.onSelect,
      onClear = _ref.onClear,
      loading = _ref.loading,
      optionsTitle = _ref.optionsTitle,
      rest = _objectWithoutProperties(_ref, ["className", "onChange", "placeholder", "options", "value", "onSelect", "onClear", "loading", "optionsTitle"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      userInput = _useState2[0],
      setUserInput = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOptionIndex = _useState4[0],
      setSelectedOptionIndex = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shouldShowDropdownOptions = _useState6[0],
      setShouldShowDropdownOptions = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedValueScrollTopValue = _useState8[0],
      setSelectedValueScrollTopValue = _useState8[1];

  var scrollContainerElement = useRef(null);
  var handleChange = useCallback(function (e) {
    // search criteria has changed
    var input = e.target.value;
    setUserInput(input);
    setSelectedOptionIndex(0);
    setShouldShowDropdownOptions(!!options.length || !!optionsTitle);
    onChange(input);
  }, [onChange, options, optionsTitle]);
  var handleClick = useCallback(function (selectedOption) {
    // one of the suggestions was clicked by user to select it
    setShouldShowDropdownOptions(false);
    onSelect(selectedOption);
    setUserInput(selectedOption.label);
    setSelectedOptionIndex(0);
  }, [onSelect]);
  var handleKeyDown = useCallback(function (e) {
    // up, down or enter key was pressed ?
    if (e.key === 'Enter') {
      // enter key pressed => set entered suggestion as active
      e.preventDefault();
      setUserInput(options[selectedOptionIndex].label);
      onSelect(options[selectedOptionIndex]);
      setSelectedOptionIndex(0);
      setShouldShowDropdownOptions(false);

      if (scrollContainerElement.current) {
        setSelectedValueScrollTopValue(scrollContainerElement.current.scrollTop);
      }
    } else if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
      // navigating using up-down arrow keys
      // highlight appropriate option as selected
      e.preventDefault();

      if (e.key === 'ArrowUp' && selectedOptionIndex === 0 || e.key === 'ArrowDown' && selectedOptionIndex >= options.length - 1) {
        return;
      }

      var targetIndex = e.key === 'ArrowUp' ? selectedOptionIndex - 1 : selectedOptionIndex + 1;

      if (e.key === 'ArrowUp') {
        if (scrollContainerElement.current) {
          scrollContainerElement.current.scrollTop = DROPDOWN_OPTION_TOTAL_HEIGHT * Math.max(targetIndex - 2, 0);
        }
      } else if (scrollContainerElement.current) {
        scrollContainerElement.current.scrollTop = DROPDOWN_OPTION_TOTAL_HEIGHT * Math.min(targetIndex - 2, options.length - 1);
      }

      setSelectedOptionIndex(targetIndex);
    } else if (e.key === 'Escape') {
      // ESC key was pressed, options should be cleared
      e.preventDefault();
      setSelectedOptionIndex(0);
      setShouldShowDropdownOptions(false); // ensure the options dropdown is scrolled appropriately to where our selected value is

      if (scrollContainerElement.current) {
        scrollContainerElement.current.scrollTop = selectedValueScrollTopValue;
      }

      onClear();
    }
  }, [options, selectedOptionIndex, onSelect, onClear, selectedValueScrollTopValue]); // Reset selected option when setting loading state

  useEffect(function () {
    if (loading) {
      setSelectedOptionIndex(0);
    }
  }, [loading]); // Determine if options can be shown when new options are received by component

  useEffect(function () {
    setShouldShowDropdownOptions(!!options.length || !!optionsTitle);

    if (scrollContainerElement.current) {
      scrollContainerElement.current.scrollTop = 0;
      setSelectedValueScrollTopValue(0);
    }
  }, [options, optionsTitle]);
  useEffect(function () {
    setUserInput(value);
  }, [value]);
  var open = !!userInput && shouldShowDropdownOptions;
  return React.createElement(React.Fragment, null, React.createElement(Input, _extends({
    className: cx('autoComplete', className),
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    value: userInput,
    placeholder: placeholder
  }, rest)), open && React.createElement("div", {
    className: cx({
      open: open
    }, 'optionBox')
  }, loading ? React.createElement("ul", {
    className: cx('options'),
    role: "listbox"
  }, React.createElement("li", {
    role: "option",
    "aria-selected": "false",
    className: cx('option')
  }, React.createElement(Loader, {
    size: "xs"
  }))) : React.createElement(React.Fragment, null, !!optionsTitle && React.createElement(Header, {
    as: "h4",
    className: cx('optionsTitle'),
    snug: true
  }, optionsTitle), React.createElement("ul", {
    className: cx('options'),
    role: "listbox",
    ref: scrollContainerElement
  }, options.map(function (option, index) {
    return React.createElement(React.Fragment, {
      key: option.value
    }, React.createElement("li", {
      id: "autocompleteOption".concat(index),
      role: "option",
      "aria-selected": index === selectedOptionIndex,
      className: cx({
        selected: index === selectedOptionIndex
      }, 'option'),
      onKeyDown: handleKeyDown,
      onClick: function onClick() {
        handleClick(option);
      }
    }, option.render ? option.render(option) : option.label), index === options.length && React.createElement(Divider, {
      className: cx('itemDivider')
    }));
  })))));
}
Autocomplete.propTypes = {
  /* Placeholder text to show when input is empty */
  placeholder: PropTypes.string,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Change handler */
  onChange: PropTypes.func,

  /** Initial value to set in the input */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Options to show for autocomplete suggestions */
  options: PropTypes.arrayOf(DropdownOption),

  /** Callback to invoke when an autocomplete option gets selected */
  onSelect: PropTypes.func,

  /** Callback to invoke when options should be cleared */
  onClear: PropTypes.func,

  /** Whether loading animation should be showed in place of autocomplete options */
  loading: PropTypes.bool,

  /** An optional title which could be displayed as title above autocomplete options */
  optionsTitle: PropTypes.string
};
Autocomplete.defaultProps = {
  className: undefined,
  value: '',
  options: [],
  onChange: noop,
  onSelect: noop,
  onClear: noop,
  loading: false,
  placeholder: undefined,
  optionsTitle: undefined
};